module.exports = __webpack_public_path__ + "img/logo-presenca-na-ausencia.4f265ac1.png";